/**
 * @generated SignedSource<<e803deb322d6a8dd7194f9b366daadfc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateTaskInput = {
  ids?: ReadonlyArray<string | null> | null;
  projectId?: string | null;
  projectGroupId?: string | null;
  parentId?: string | null;
  phaseId?: string | null;
  aboveTaskId?: string | null;
  aboveFavouredTaskId?: string | null;
  name?: string | null;
  description?: string | null;
  estimateLow?: number | null;
  estimateHigh?: number | null;
  forecast?: number | null;
  timeLeft?: number | null;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  deadlineYear?: number | null;
  deadlineMonth?: number | null;
  deadlineDay?: number | null;
  roleId?: string | null;
  assignedPersons?: ReadonlyArray<string | null> | null;
  unassignAllPersons?: boolean | null;
  assignedPersonToAdd?: string | null;
  followers?: ReadonlyArray<string | null> | null;
  removeAllFollowers?: boolean | null;
  labels?: ReadonlyArray<string | null> | null;
  clearAllLabels?: boolean | null;
  sprintId?: string | null;
  projectGroupSprintId?: string | null;
  statusColumnId?: string | null;
  statusColumnV2Id?: string | null;
  projectGroupStatusColumnId?: number | null;
  coverFileId?: string | null;
  blocked?: boolean | null;
  bug?: boolean | null;
  approved?: boolean | null;
  billable?: boolean | null;
  repeatingTaskId?: string | null;
  unassignedTaskId?: string | null;
  previousProjectId?: string | null;
  unassignPersonFromTask?: ReadonlyArray<UnassignPersonFromTask | null> | null;
  remaining?: number | null;
  highPriority?: boolean | null;
  ownerId?: string | null;
  favoured?: boolean | null;
  favouredSortOrder?: string | null;
  parentTaskId?: string | null;
  previousParentTaskId?: string | null;
  isBulkContext?: boolean | null;
  validateDependencies?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UnassignPersonFromTask = {
  taskId: string;
  personIds?: ReadonlyArray<string | null> | null;
};
export type updateTaskMutationModernMutation$variables = {
  input: UpdateTaskInput;
};
export type updateTaskMutationModernMutation$data = {
  readonly updateTask: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly updatedTasksIds: ReadonlyArray<string | null> | null;
    readonly childrenTasks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly sprint: {
            readonly id: string;
          } | null;
          readonly phase: {
            readonly id: string;
          } | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
          readonly deadlineFrom: string | null;
          readonly startDay: number | null;
          readonly startMonth: number | null;
          readonly startYear: number | null;
          readonly startFrom: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly taskEdge: {
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"DraggableCard_task">;
      } | null;
    } | null;
    readonly taskEdges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"DraggableCard_task">;
      } | null;
    } | null> | null;
    readonly parentTask: {
      readonly id: string;
      readonly childrenTasks: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly previousParentTask: {
      readonly id: string;
      readonly childrenTasks: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly tasks: ReadonlyArray<{
      readonly id: string;
      readonly assignedPersons: ReadonlyArray<{
        readonly id: string;
      } | null> | null;
      readonly parentTaskId: string | null;
      readonly parentTask: {
        readonly id: string;
      } | null;
      readonly billable: boolean | null;
      readonly blocked: boolean | null;
      readonly bug: boolean | null;
      readonly companyTaskId: number | null;
      readonly deadlineDay: number | null;
      readonly deadlineMonth: number | null;
      readonly deadlineYear: number | null;
      readonly deadlineFrom: string | null;
      readonly startFrom: string | null;
      readonly done: boolean | null;
      readonly highPriority: boolean | null;
      readonly role: {
        readonly id: string;
      } | null;
      readonly phase: {
        readonly id: string;
        readonly progress: number | null;
        readonly progressDetails: {
          readonly progress: number | null;
        } | null;
      } | null;
      readonly sprint: {
        readonly id: string;
      } | null;
      readonly statusColumnV2: {
        readonly id: string;
      } | null;
      readonly progress: number | null;
      readonly startDay: number | null;
      readonly startMonth: number | null;
      readonly startYear: number | null;
      readonly timeLeft: number | null;
      readonly timeLeftMinutesWithoutFutureTimeRegs: number | null;
      readonly hasChildren: boolean | null;
      readonly name: string | null;
      readonly progressDetails: {
        readonly progress: number | null;
      } | null;
      readonly estimateForecast: number | null;
      readonly estimateForecastPrice: number | null;
      readonly estimateForecastMinutes: number | null;
      readonly approved: boolean | null;
      readonly currentPrice: number | null;
      readonly allTotalTimeAndExpensesAtCompletion: number | null;
      readonly plannedCost: number | null;
      readonly actualCost: number | null;
      readonly taskLabels: ReadonlyArray<{
        readonly label: {
          readonly id: string;
          readonly name: string | null;
          readonly color: string | null;
        } | null;
      } | null> | null;
      readonly project: {
        readonly id: string;
        readonly completion: number | null;
        readonly remaining: number | null;
        readonly forecast: number | null;
        readonly progress: number | null;
        readonly progressDetails: {
          readonly progress: number | null;
        } | null;
      } | null;
      readonly owner: {
        readonly id: string;
      } | null;
      readonly followers: ReadonlyArray<{
        readonly id: string;
      } | null> | null;
      readonly timeRegistrations: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly billableMinutesRegistered: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"DraggableCard_task">;
    } | null> | null;
  } | null;
};
export type updateTaskMutationModernMutation = {
  variables: updateTaskMutationModernMutation$variables;
  response: updateTaskMutationModernMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedTasksIds",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Sprint",
  "kind": "LinkedField",
  "name": "sprint",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskTypeConnection",
  "kind": "LinkedField",
  "name": "childrenTasks",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "PhaseType",
              "kind": "LinkedField",
              "name": "phase",
              "plural": false,
              "selections": (v5/*: any*/),
              "storageKey": null
            },
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "DraggableCard_task"
},
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v16/*: any*/)
    ],
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TaskTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v18/*: any*/)
        ],
        "storageKey": null
      },
      (v19/*: any*/)
    ],
    "storageKey": null
  },
  (v20/*: any*/)
],
v22 = [
  (v4/*: any*/),
  {
    "alias": "childrenTasks",
    "args": null,
    "concreteType": "TaskTypeConnection",
    "kind": "LinkedField",
    "name": "__ParentTask_childrenTasks_connection",
    "plural": false,
    "selections": (v21/*: any*/),
    "storageKey": null
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentTaskId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocked",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bug",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v31 = [
  (v30/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeftMinutesWithoutFutureTimeRegs",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChildren",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecast",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecastPrice",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecastMinutes",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentPrice",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allTotalTimeAndExpensesAtCompletion",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedCost",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualCost",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v35/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completion",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remaining",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "forecast",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "followers",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billableMinutesRegistered",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestUiUpdateAt",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favouredSortOrder",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalMinutesRegistered",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskReadOnly",
  "kind": "LinkedField",
  "name": "readOnly",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isReadOnly",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCanDeleteTask",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCantDeleteTaskReason",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctId",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraId",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsId",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subTaskCount",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileCount",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasInvoicedTime",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "parentTask",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v68/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectGroupStatusColumnId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskLabel",
  "kind": "LinkedField",
  "name": "taskLabels",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v44/*: any*/)
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "coverFile",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v35/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupId",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "Unit4ProjectType",
  "kind": "LinkedField",
  "name": "unit4Project",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activitiesEnabled",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoDefaultId",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProgramRevenueLocked",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programBudgetType",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v88 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusColumnV2",
  "kind": "LinkedField",
  "name": "statusColumnV2",
  "plural": false,
  "selections": [
    (v68/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": (v88/*: any*/),
  "concreteType": "DependencyTypeConnection",
  "kind": "LinkedField",
  "name": "thisTaskDependsOn",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DependencyTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DependencyType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v89/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "thisDependsOnTask",
              "plural": false,
              "selections": [
                (v90/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            },
            (v18/*: any*/)
          ],
          "storageKey": null
        },
        (v19/*: any*/)
      ],
      "storageKey": null
    },
    (v20/*: any*/)
  ],
  "storageKey": "thisTaskDependsOn(first:1000)"
},
v92 = {
  "alias": null,
  "args": (v88/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "Task_thisTaskDependsOn",
  "kind": "LinkedHandle",
  "name": "thisTaskDependsOn"
},
v93 = {
  "alias": null,
  "args": (v88/*: any*/),
  "concreteType": "DependencyTypeConnection",
  "kind": "LinkedField",
  "name": "dependsOnThisTask",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DependencyTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DependencyType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v89/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "taskDependsOnThis",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v90/*: any*/)
              ],
              "storageKey": null
            },
            (v18/*: any*/)
          ],
          "storageKey": null
        },
        (v19/*: any*/)
      ],
      "storageKey": null
    },
    (v20/*: any*/)
  ],
  "storageKey": "dependsOnThisTask(first:1000)"
},
v94 = {
  "alias": null,
  "args": (v88/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "Task_dependsOnThisTask",
  "kind": "LinkedHandle",
  "name": "dependsOnThisTask"
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "assignedPersons",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilePictureDefaultId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    (v66/*: any*/)
  ],
  "storageKey": null
},
v96 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v4/*: any*/),
      (v24/*: any*/),
      (v51/*: any*/),
      (v52/*: any*/),
      (v32/*: any*/),
      (v30/*: any*/),
      (v53/*: any*/),
      (v38/*: any*/),
      (v54/*: any*/),
      (v27/*: any*/),
      (v55/*: any*/),
      (v56/*: any*/),
      (v57/*: any*/),
      (v34/*: any*/),
      (v58/*: any*/),
      (v35/*: any*/),
      (v59/*: any*/),
      (v29/*: any*/),
      (v26/*: any*/),
      (v25/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v60/*: any*/),
      (v61/*: any*/),
      (v9/*: any*/),
      (v62/*: any*/),
      (v63/*: any*/),
      (v64/*: any*/),
      (v28/*: any*/),
      (v23/*: any*/),
      (v65/*: any*/),
      (v66/*: any*/),
      (v67/*: any*/),
      (v69/*: any*/),
      (v70/*: any*/),
      (v71/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v72/*: any*/),
          (v73/*: any*/),
          (v35/*: any*/),
          (v74/*: any*/),
          (v75/*: any*/),
          (v76/*: any*/),
          (v77/*: any*/),
          (v78/*: any*/),
          (v79/*: any*/),
          (v80/*: any*/),
          (v81/*: any*/),
          (v82/*: any*/),
          (v83/*: any*/),
          (v84/*: any*/),
          (v85/*: any*/),
          (v86/*: any*/),
          (v87/*: any*/)
        ],
        "storageKey": null
      },
      (v91/*: any*/),
      (v92/*: any*/),
      (v93/*: any*/),
      (v94/*: any*/),
      (v95/*: any*/)
    ],
    "storageKey": null
  }
],
v97 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v98 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": (v97/*: any*/),
    "concreteType": "TaskTypeConnection",
    "kind": "LinkedField",
    "name": "childrenTasks",
    "plural": false,
    "selections": (v21/*: any*/),
    "storageKey": "childrenTasks(first:1000000)"
  },
  {
    "alias": null,
    "args": (v97/*: any*/),
    "filters": ([]/*: any*/),
    "handle": "connection",
    "key": "ParentTask_childrenTasks",
    "kind": "LinkedHandle",
    "name": "childrenTasks"
  }
],
v99 = [
  (v30/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTaskMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTaskPayload",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdge",
            "plural": false,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdges",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "parentTask",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "previousParentTask",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "assignedPersons",
                "plural": true,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Task",
                "kind": "LinkedField",
                "name": "parentTask",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v14/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "role",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseType",
                "kind": "LinkedField",
                "name": "phase",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v31/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StatusColumnV2",
                "kind": "LinkedField",
                "name": "statusColumnV2",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              (v30/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskProgress",
                "kind": "LinkedField",
                "name": "progressDetails",
                "plural": false,
                "selections": (v31/*: any*/),
                "storageKey": null
              },
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskLabel",
                "kind": "LinkedField",
                "name": "taskLabels",
                "plural": true,
                "selections": [
                  (v44/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v31/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v48/*: any*/),
              (v49/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeRegTypeConnection",
                "kind": "LinkedField",
                "name": "timeRegistrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTaskMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateTaskPayload",
        "kind": "LinkedField",
        "name": "updateTask",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdge",
            "plural": false,
            "selections": (v96/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskTypeEdge",
            "kind": "LinkedField",
            "name": "taskEdges",
            "plural": true,
            "selections": (v96/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "parentTask",
            "plural": false,
            "selections": (v98/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "previousParentTask",
            "plural": false,
            "selections": (v98/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "tasks",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v24/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v32/*: any*/),
              (v30/*: any*/),
              (v53/*: any*/),
              (v38/*: any*/),
              (v54/*: any*/),
              (v27/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v34/*: any*/),
              (v58/*: any*/),
              (v35/*: any*/),
              (v59/*: any*/),
              (v29/*: any*/),
              (v26/*: any*/),
              (v25/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v9/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v28/*: any*/),
              (v23/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v72/*: any*/),
                  (v73/*: any*/),
                  (v35/*: any*/),
                  (v74/*: any*/),
                  (v75/*: any*/),
                  (v76/*: any*/),
                  (v77/*: any*/),
                  (v78/*: any*/),
                  (v79/*: any*/),
                  (v80/*: any*/),
                  (v81/*: any*/),
                  (v82/*: any*/),
                  (v83/*: any*/),
                  (v84/*: any*/),
                  (v85/*: any*/),
                  (v86/*: any*/),
                  (v87/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v99/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v91/*: any*/),
              (v92/*: any*/),
              (v93/*: any*/),
              (v94/*: any*/),
              (v95/*: any*/),
              (v10/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseType",
                "kind": "LinkedField",
                "name": "phase",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseProgress",
                    "kind": "LinkedField",
                    "name": "progressDetails",
                    "plural": false,
                    "selections": (v99/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              (v33/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaskProgress",
                "kind": "LinkedField",
                "name": "progressDetails",
                "plural": false,
                "selections": (v99/*: any*/),
                "storageKey": null
              },
              (v36/*: any*/),
              (v37/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeRegTypeConnection",
                "kind": "LinkedField",
                "name": "timeRegistrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeRegTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRegType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v50/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f44abc5b88c7e3cb7e8cb56c6553c6c9",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateTask",
            "parentTask",
            "childrenTasks"
          ]
        },
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "updateTask",
            "previousParentTask",
            "childrenTasks"
          ]
        }
      ]
    },
    "name": "updateTaskMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateTaskMutationModernMutation(\n  $input: UpdateTaskInput!\n) {\n  updateTask(input: $input) {\n    errors\n    updatedTasksIds\n    childrenTasks {\n      edges {\n        node {\n          id\n          sprint {\n            id\n          }\n          phase {\n            id\n          }\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n          deadlineFrom\n          startDay\n          startMonth\n          startYear\n          startFrom\n        }\n      }\n    }\n    taskEdge {\n      node {\n        id\n        ...DraggableCard_task\n      }\n    }\n    taskEdges {\n      node {\n        id\n        ...DraggableCard_task\n      }\n    }\n    parentTask {\n      id\n      childrenTasks(first: 1000000) {\n        edges {\n          node {\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    previousParentTask {\n      id\n      childrenTasks(first: 1000000) {\n        edges {\n          node {\n            id\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    tasks {\n      id\n      ...DraggableCard_task\n      assignedPersons {\n        id\n      }\n      parentTaskId\n      parentTask {\n        id\n      }\n      billable\n      blocked\n      bug\n      companyTaskId\n      deadlineDay\n      deadlineMonth\n      deadlineYear\n      deadlineFrom\n      startFrom\n      done\n      highPriority\n      role {\n        id\n      }\n      phase {\n        id\n        progress\n        progressDetails {\n          progress\n          id\n        }\n      }\n      sprint {\n        id\n      }\n      statusColumnV2 {\n        id\n      }\n      progress\n      startDay\n      startMonth\n      startYear\n      timeLeft\n      timeLeftMinutesWithoutFutureTimeRegs\n      hasChildren\n      name\n      progressDetails {\n        progress\n        id\n      }\n      estimateForecast\n      estimateForecastPrice\n      estimateForecastMinutes\n      approved\n      currentPrice\n      allTotalTimeAndExpensesAtCompletion\n      plannedCost\n      actualCost\n      taskLabels {\n        label {\n          id\n          name\n          color\n        }\n        id\n      }\n      project {\n        id\n        completion\n        remaining\n        forecast\n        progress\n        progressDetails {\n          progress\n          id\n        }\n      }\n      owner {\n        id\n      }\n      followers {\n        id\n      }\n      timeRegistrations {\n        edges {\n          node {\n            billableMinutesRegistered\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment DraggableCard_task on Task {\n  id\n  billable\n  latestUiUpdateAt\n  description\n  timeLeft\n  progress\n  favouredSortOrder\n  estimateForecastMinutes\n  totalMinutesRegistered\n  companyTaskId\n  readOnly {\n    isReadOnly\n    id\n  }\n  userCanDeleteTask\n  userCantDeleteTaskReason\n  hasChildren\n  sageIntacctId\n  name\n  favoured\n  highPriority\n  bug\n  blocked\n  startDay\n  startMonth\n  startYear\n  deadlineDay\n  deadlineMonth\n  jiraId\n  vstsId\n  deadlineYear\n  subTaskCount\n  fileCount\n  commentCount\n  done\n  parentTaskId\n  hasInvoicedTime\n  role {\n    id\n    name\n  }\n  parentTask {\n    name\n    id\n  }\n  statusColumnV2 {\n    id\n    category\n    projectGroupStatusColumnId\n  }\n  taskLabels {\n    id\n    label {\n      id\n      name\n      color\n    }\n  }\n  coverFile {\n    id\n    name\n    key\n  }\n  project {\n    id\n    companyProjectId\n    projectColor\n    name\n    status\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    projectGroupId\n    unit4Project {\n      activitiesEnabled\n      id\n    }\n    harvestProject {\n      id\n    }\n    client {\n      name\n      logoId\n      logoDefaultId\n      id\n    }\n    isProgramRevenueLocked\n    programBudgetType\n    ...DeprecatedProjectIndicatorJS_project\n  }\n  thisTaskDependsOn(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        thisDependsOnTask {\n          statusColumnV2 {\n            category\n            id\n          }\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  dependsOnThisTask(first: 1000) {\n    edges {\n      node {\n        id\n        type\n        taskDependsOnThis {\n          id\n          statusColumnV2 {\n            category\n            id\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  assignedPersons {\n    id\n    firstName\n    lastName\n    fullName\n    email\n    profilePictureId\n    profilePictureDefaultId\n    active\n    permissions\n    role {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd22f4fac89f668c99aa85c3f0ec0065";

export default node;
